import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { BRAND } from "@/lib/brand";
import { LogOut, ChevronLeft } from "lucide-react";

export default function DashboardShell({ title, eyebrow, children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="nkf-container py-3 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 group shrink-0">
            <img src={BRAND.logo} alt="NKF" className="h-10 w-10 sm:h-11 sm:w-11 object-contain rounded-full" />
            <div className="hidden sm:block">
              <div className="font-display text-nkf-red text-sm sm:text-base leading-tight">NKF Bharat</div>
              <div className="text-[10px] uppercase tracking-widest text-slate-500 inline-flex items-center gap-1 group-hover:text-nkf-blue transition">
                <ChevronLeft className="h-3 w-3" /> Public site
              </div>
            </div>
          </Link>
          <div className="min-w-0 flex-1 text-center">
            <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.3em] text-nkf-red font-semibold">{eyebrow}</div>
            <h1 className="font-display text-lg sm:text-xl md:text-2xl text-nkf-blue leading-tight truncate">{title}</h1>
          </div>
          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            <div className="hidden md:block text-right">
              <div className="text-xs font-semibold text-nkf-blue truncate max-w-[180px]">{user?.name}</div>
              <div className="text-[10px] uppercase tracking-widest text-slate-500 truncate max-w-[180px]">{user?.email}</div>
            </div>
            <button
              onClick={async () => { await logout(); nav("/"); }}
              data-testid="logout-btn"
              className="inline-flex items-center gap-1.5 bg-nkf-blue hover:bg-nkf-navy text-white text-[11px] sm:text-xs uppercase tracking-widest font-bold px-3 sm:px-4 py-2 rounded transition"
            >
              <LogOut className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Sign Out</span>
            </button>
          </div>
        </div>
      </header>
      <main className="nkf-container py-6 sm:py-8 md:py-10">{children}</main>
    </div>
  );
}
